import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import LOOKUP from 'constants/lookup';
import { getCombos, deleteCombo } from 'actions/EntityActions';
import { comboListCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
// Basic Components
import Grid from 'screens/components/basic/Grid';
import Button from 'screens/components/basic/Button';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
// Advanced Components
import GenericTable from 'screens/components/advanced/GenericTable';
import DialogInputNew from 'screens/components/advanced/DialogInputNew';

class ComboList extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            confirmDeleteDialog: false
        };
    }

    redirectToAddPage = () => {
        this.props.navigate("/manage/combo/add");
    }

    redirectToEditPage = (id) => {
        this.props.navigate(`/manage/combo/edit/${id}`);
    }

    openConfirmDeleteDialog = (itemId) => {
        this.setState({ confirmDeleteDialog: true, itemId });
    };

    closeConfirmDeleteDialog = () => {
        this.setState({ confirmDeleteDialog: false });
    };

    confirmDeleteCombo = (comboId) => {
        this.setState({ confirmDeleteDialog: false });
        this.props.deleteCombo(this.props.branchId, comboId);
    }

    componentDidMount() {
        this.props.getCombos({
            branchId: this.props.branchId,
            onlyActive: false
        });
    }

    render() {
        const p = this.props;

        const tableRows = p.combos.map(item => {
            return {
                Name: (<Link className="edit-link" to={`/manage/combo/edit/${item.id}`}>{item.name}</Link>),
                Price: (<span>$ {item.price}</span>),
                Status: (item.status !== 1 ? <p className="statusIconRed m-0">InActive</p> :
                    <p className="statusIconGreen m-0">Active</p>),
                    EditIcon: (
                        <Button
                            type="IconEditButton"
                            mini={true}
                            onTouchTap={() => this.redirectToEditPage(item.id)}
                        />
                    ),
                    DeleteIcon: (
                        <Button
                            mini={true}
                            type="IconDeleteButton"
                            className="glyphicon-remove-circle"
                            onTouchTap={() => this.openConfirmDeleteDialog(item.id)}
                        />
                    )
            };
        });

        return (
            <Grid headerContent={comboListCrumb}>
                <PageHeaderWithButton title={LOOKUP.menu.manage.items.combo.text}>
                    <Button
                        type="AddButton"
                        mini={true}
                        className="bg-light-green"
                        label={LOOKUP.combo.controls.addNewButton}
                        onTouchTap={() => this.redirectToAddPage()}
                    />
                </PageHeaderWithButton>
                <GenericTable
                    className="table_center tableHeaderwhiteColorFont"
                    tableBodyClassName="campaigns-table"
                    multiSelectable={false}
                    enableSelectAll={false}
                    selectable={false}
                    columns={LOOKUP.combo.tableColumns}
                    rows={tableRows}
                    stripedRows={true}
                />
                <DialogInputNew
                    title="CONFIRM DELETE" 
                    handleClose={() => this.closeConfirmDeleteDialog()}
                    open={this.state.confirmDeleteDialog}
                    style={{ zIndex: "950" }}
                    actions={[
                        <Button
                            key={2}
                            name="ConfirmDelete"
                            label="Delete"
                            primary={true}
                            className="btn-space-20"
                            onTouchTap={() => this.confirmDeleteCombo(this.state.itemId)}
                        />
                    ]}
                    contentStyle={{ width: "65%" }}
                >
                    <p className="purpleText">
                        Are you sure you wish to delete this combo?
                    </p>
                </DialogInputNew>
            </Grid>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        combos: state.entity.comboList || [],
        branchId: state.common.branchId
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getCombos: (model) => dispatch(getCombos(model)),
        deleteCombo: (branchId, comboId) => dispatch(deleteCombo(branchId, comboId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(ComboList));